import React, { useState, useEffect } from 'react';
import IosCard from '../../components/iOSCard';
import { db, auth } from '../../firebase'; // تم إضافة auth هنا يا ضلع
import { 
    collection, addDoc, getDocs, query, orderBy, deleteDoc, doc, updateDoc, serverTimestamp 
} from "firebase/firestore";
import { 
    AcademicCapIcon, 
    PlusIcon, 
    CheckCircleIcon, 
    TrashIcon, 
    PencilSquareIcon,
    PaperAirplaneIcon,
    QueueListIcon,
    PlusCircleIcon,
    ListBulletIcon,
    XMarkIcon,
    ExclamationTriangleIcon
} from '@heroicons/react/24/outline';
import { motion, AnimatePresence } from 'framer-motion';
// ✅ استيراد الدالة البارونية للإرسال المركزي
import { sendNotification } from '../../firebase'; 

// [REF: GLASS_MODAL_COMPONENTS] - مكونات زجاجية فرعية للرسائل المنبثقة بالوسط
const GlassConfirmModal = ({ isOpen, title, desc, onConfirm, onCancel, type = "danger" }) => (
    <AnimatePresence>
        {isOpen && (
            <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }} className="fixed inset-0 z-[10000] flex items-center justify-center p-6 backdrop-blur-md bg-black/40">
                <motion.div initial={{ scale: 0.9, y: 20, opacity: 0 }} animate={{ scale: 1, y: 0, opacity: 1 }} exit={{ scale: 0.9, y: 20, opacity: 0 }} className="ios-glass max-w-sm w-full bg-white/95 dark:bg-[#1C1C1E]/90 p-8 rounded-[40px] shadow-2xl border border-white/20 text-center space-y-6">
                    <div className={`w-16 h-16 rounded-2xl flex items-center justify-center mx-auto ${type === 'danger' ? 'bg-red-100 text-red-600' : 'bg-blue-100 text-blue-600'}`}>
                        {type === 'danger' ? <ExclamationTriangleIcon className="w-10 h-10" /> : <CheckCircleIcon className="w-10 h-10" />}
                    </div>
                    <div>
                        <h3 className="text-xl font-black text-gray-900 dark:text-white font-cairo">{title}</h3>
                        <p className="text-sm font-bold text-gray-500 dark:text-gray-400 mt-2 leading-relaxed font-cairo text-center">{desc}</p>
                    </div>
                    <div className="flex gap-3 pt-2 font-cairo">
                        <button onClick={onConfirm} className={`flex-1 py-4 ${type === 'danger' ? 'bg-red-500' : 'bg-[#007AFF]'} text-white rounded-2xl font-black shadow-lg active:scale-95 transition-all`}>تأكيد</button>
                        <button onClick={onCancel} className="flex-1 py-4 bg-gray-100 dark:bg-white/10 text-gray-800 dark:text-white rounded-2xl font-black active:scale-95 transition-all">إلغاء</button>
                    </div>
                </motion.div>
            </motion.div>
        )}
    </AnimatePresence>
);

const QuizManager = () => {
    const [quizzes, setQuizzes] = useState([]);
    const [isAdding, setIsAdding] = useState(false);
    const [isEditing, setIsEditing] = useState(false);
    const [editingQuizId, setEditingQuizId] = useState(null);

    const [selectedCourse, setSelectedCourse] = useState('كورس أول');
    const [selectedChapter, setSelectedChapter] = useState('الفصل الأول');
    const [quizTitle, setQuizTitle] = useState("");
    const [showSuccessModal, setShowSuccessModal] = useState(false);
    
    // [SECTION: NEW_MODAL_STATES] - حالات المودالات الجديدة للتصميم الزجاجي
    const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
    const [quizToDelete, setQuizToDelete] = useState(null);
    const [customAlert, setCustomAlert] = useState({ show: false, msg: "", type: "info" });

    const [newQText, setNewQText] = useState("");
    const [options, setOptions] = useState(["", "", "", ""]);
    const [correctIndex, setCorrectIndex] = useState(0);
    const [questions, setQuestions] = useState([]);
    const [isPublishing, setIsPublishing] = useState(false);

    // 1️⃣ جلب البيانات من Firestore
    useEffect(() => {
        const fetchQuizzes = async () => {
            try {
                const q = query(collection(db, "quizzes"), orderBy("createdAt", "desc"));
                const querySnapshot = await getDocs(q);
                setQuizzes(querySnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() })));
            } catch (error) { console.error("Error fetching:", error); }
        };
        fetchQuizzes();
    }, []);

    // [AL-BARON_SECURITY_CHECK] - دالة التنبيه الزجاجي الملكي
    const triggerAlert = (msg, type = "info") => {
        setCustomAlert({ show: true, msg, type });
        if (type !== 'error') {
            setTimeout(() => setCustomAlert({ show: false, msg: "", type: "info" }), 3000);
        }
    };

    // 📝 دالة تفعيل وضع التعديل
    const startEdit = (quiz) => {
        setIsEditing(true);
        setIsAdding(true);
        setEditingQuizId(quiz.id);
        setQuizTitle(quiz.title);
        setSelectedCourse(quiz.courseType);
        setSelectedChapter(quiz.chapter);
        setQuestions(quiz.questions || []);
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    const handleOptionChange = (index, value) => {
        const newOptions = [...options];
        newOptions[index] = value;
        setOptions(newOptions);
    };

    // ✅ 1. دالة إضافة سؤال للمسودة
    const addQuestionToBank = () => {
        if (!newQText.trim() || options.some(opt => !opt.trim())) {
             return triggerAlert("عضيدي، املأ كل حقول السؤال والخيارات أولاً! ⚠️", "error");
        }

        const newQuestion = {
            id: Date.now(),
            text: newQText,
            options: [...options],
            correct: correctIndex
        };
        setQuestions([...questions, newQuestion]);
        setNewQText("");
        setOptions(["", "", "", ""]);
        setCorrectIndex(0);
        triggerAlert("تمت إضافة السؤال للمسودة ✨", "success");
    };

    const removeQuestionFromDraft = (id) => {
        setQuestions(questions.filter(q => q.id !== id));
    };

    // 🗑️ نظام الحذف الزجاجي المطور لعام 2026
    const openDeleteConfirm = (id) => {
        setQuizToDelete(id);
        setIsDeleteModalOpen(true);
    };

    const handleDeleteQuiz = async () => {
        try {
            await deleteDoc(doc(db, "quizzes", quizToDelete));
            setQuizzes(quizzes.filter(q => q.id !== quizToDelete));
            setIsDeleteModalOpen(false);
            triggerAlert("تم حذف الاختبار بنجاح 🗑️", "success");
        } catch (error) { 
            console.error("حذف فاشل:", error); 
            triggerAlert("فشل الحذف، شيك الاتصال ضلعي", "error");
        }
    };

    // ✅ 2. دالة النشر أو التحديث (نظام التنبيهات الزجاجي المحسن)
    const handleAction = async () => {
        if (!quizTitle.trim() || questions.length === 0) {
             return triggerAlert("يا غالي، لازم عنوان واختبار بيه أسئلة على الأقل! ⚠️", "error");
        }
        
        setIsPublishing(true);
        try {
            const quizData = {
                title: quizTitle,
                courseType: selectedCourse,
                chapter: selectedChapter,
                questions: questions,
                instructor: "الأستاذة نور عماد",
                status: "published",
                updatedAt: serverTimestamp()
            };

            // ✅ التعديل الباروني: استخدام addDoc لضمان إرسال الإشعار "للجميع"
if (!isEditing) {
    const docRef = await addDoc(collection(db, "quizzes"), { ...quizData, createdAt: serverTimestamp() });
    
    // هنا "النيشان" اللي يخلي الجرس يهتز عند كل طالب:
    await addDoc(collection(db, "notifications"), {
        message: "📝 تم نشر اختبار جديد: " + quizTitle,
        text: "اختبار جديد بانتظارك، ادخل للمنصة واختبر نفسك!",
        createdAt: serverTimestamp(),
        type: 'exam',           // نوعه اختبار
        targetId: 'all',        // هذا هو المفتاح! لازم 'all' ليوصل للكل
        isRead: false,          // هذا الزناد اللي يهز الجرس
        role: 'student'
    });

    setQuizzes([{ id: docRef.id, ...quizData }, ...quizzes]);
}

            setShowSuccessModal(true); 
            setTimeout(() => {
                setShowSuccessModal(false);
                resetForm();
            }, 2500);
        } catch (e) { 
            console.error("فشل العملية:", e); 
            triggerAlert("صار خلل بالنشر، حاول مرة ثانية", "error");
        } finally { 
            setIsPublishing(false); 
        }
    };

    const resetForm = () => {
        setIsAdding(false);
        setIsEditing(false);
        setEditingQuizId(null);
        setQuizTitle("");
        setQuestions([]);
        setNewQText("");
    };

    return (
        <div style={{ fontFamily: "'Cairo', sans-serif" }} className="space-y-6 animate-in fade-in slide-in-from-bottom-4 duration-700 h-full flex flex-col relative text-right font-cairo" dir="rtl">
            
            {/* 🛡️ [AL-BARON_MODALS] - مودالات التأكيد والتنبيه الزجاجية المنبثقة */}
            <GlassConfirmModal 
                isOpen={isDeleteModalOpen}
                title="حذف الاختبار؟"
                desc="هل أنت متأكد من حذف هذا الاختبار نهائياً؟ لا يمكن التراجع عن هذا الإجراء."
                onConfirm={handleDeleteQuiz}
                onCancel={() => setIsDeleteModalOpen(false)}
            />

            {/* 📱 نظام تنبيهات الوسط الملكي */}
            <AnimatePresence>
                {customAlert.show && (
                    <div className="fixed inset-0 z-[10001] flex items-center justify-center pointer-events-none p-6">
                        <motion.div initial={{ opacity: 0, scale: 0.8 }} animate={{ opacity: 1, scale: 1 }} exit={{ opacity: 0, scale: 0.8 }} className="ios-glass bg-white/95 dark:bg-[#1C1C1E]/90 backdrop-blur-2xl border border-white/20 px-8 py-6 rounded-[35px] shadow-2xl flex flex-col items-center gap-4 text-center pointer-events-auto max-w-xs">
                            <div className={`p-4 rounded-2xl ${customAlert.type === 'error' ? 'bg-red-500' : 'bg-emerald-500'} text-white shadow-lg`}>
                                {customAlert.type === 'error' ? <ExclamationTriangleIcon className="w-8 h-8" /> : <CheckCircleIcon className="w-8 h-8" />}
                            </div>
                            <span className="font-black text-sm dark:text-white leading-relaxed">{customAlert.msg}</span>
                        </motion.div>
                    </div>
                )}
            </AnimatePresence>

            {/* هيدر الإجراءات */}
            <div className="ios-glass p-5 flex justify-between items-center shrink-0 border-white/40 dark:border-white/10 shadow-lg rounded-[30px]">
                <div className="flex items-center gap-3 text-right">
                    <div className="p-3 bg-[#AF52DE] rounded-2xl text-white shadow-lg">
                        <AcademicCapIcon className="w-6 h-6" />
                    </div>
                    <div>
                        <h2 className="text-2xl font-black text-gray-800 dark:text-white tracking-tight">إدارة الاختبارات</h2>
                        <p className="text-[10px] text-gray-400 font-bold mt-1 uppercase">بإشراف الأستاذة نور عماد</p>
                    </div>
                </div>
                <button onClick={() => isAdding ? resetForm() : setIsAdding(true)} className="flex items-center gap-2 px-6 py-3 bg-[#007AFF] text-white rounded-[20px] font-black shadow-lg hover:scale-105 active:scale-95 transition-all text-sm">
                    {isAdding ? <XMarkIcon className="w-5 h-5"/> : <PlusIcon className="w-5 h-5" />}
                    {isAdding ? "إلغاء وإغلاق" : "إنشاء اختبار جديد"}
                </button>
            </div>

            <div className="flex-1 min-h-0">
                <AnimatePresence mode="wait">
                    {isAdding ? (
                        <motion.div key="creator" initial={{ opacity: 0, x: 20 }} animate={{ opacity: 1, x: 0 }} exit={{ opacity: 0, x: -20 }} className="grid grid-cols-1 lg:grid-cols-2 gap-6 pb-32">
                            
                            <IosCard title={isEditing ? "تعديل الاختبار الحالي" : "إضافة أسئلة للمسودة"} icon={<PlusCircleIcon className="w-5 h-5"/>} color="blue">
                                <div className="space-y-4">
                                    <div className="grid grid-cols-2 gap-3">
                                        <select value={selectedCourse} onChange={(e) => setSelectedCourse(e.target.value)} className="p-4 rounded-2xl ios-glass border-none outline-none font-bold text-gray-700 dark:text-white text-xs cursor-pointer bg-white/50 dark:bg-black/20">
                                            <option className="bg-white dark:bg-[#1C1C1E]">كورس أول</option>
                                            <option className="bg-white dark:bg-[#1C1C1E]">كورس ثاني</option>
                                        </select>
                                        <select value={selectedChapter} onChange={(e) => setSelectedChapter(e.target.value)} className="p-4 rounded-2xl ios-glass border-none outline-none font-bold text-gray-700 dark:text-white text-xs cursor-pointer bg-white/50 dark:bg-black/20">
                                            {selectedCourse === 'كورس أول' ? <><option className="bg-white dark:bg-[#1C1C1E]">الفصل الأول</option><option className="bg-white dark:bg-[#1C1C1E]">الفصل الثاني</option><option className="bg-white dark:bg-[#1C1C1E]">الفصل الثالث</option></> : <><option className="bg-white dark:bg-[#1C1C1E]">الفصل الرابع</option><option className="bg-white dark:bg-[#1C1C1E]">الفصل الخامس</option></>}
                                        </select>
                                    </div>
                                    <input type="text" value={quizTitle} onChange={(e) => setQuizTitle(e.target.value)} placeholder="عنوان الاختبار..." className="w-full p-4 rounded-2xl ios-glass bg-white/50 dark:bg-white/5 border-white/20 outline-none font-bold text-gray-700 dark:text-white" />
                                    
                                    <div className="p-5 bg-white/30 dark:bg-black/20 rounded-[25px] border border-white/20 space-y-4">
                                        <textarea value={newQText} onChange={(e) => setNewQText(e.target.value)} placeholder="اكتب السؤال هنا..." className="w-full p-4 rounded-xl bg-white dark:bg-white/5 border-none outline-none font-bold text-gray-700 dark:text-white min-h-[80px]" />
                                        <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                                            {options.map((opt, i) => (
                                                <div key={i} className={`flex items-center gap-2 p-1 rounded-2xl border transition-all ${correctIndex === i ? 'bg-emerald-50 dark:bg-emerald-500/10 border-emerald-300' : 'bg-white/60 dark:bg-white/5 border-transparent'}`}>
                                                    <input type="text" value={opt} onChange={(e) => handleOptionChange(i, e.target.value)} placeholder={`الخيار ${i + 1}`} className="flex-1 bg-transparent border-none outline-none font-bold text-gray-700 dark:text-white text-xs px-2" />
                                                    <button onClick={() => setCorrectIndex(i)} className={`w-10 h-10 rounded-xl flex items-center justify-center transition-all ${correctIndex === i ? 'bg-emerald-500 text-white shadow-lg' : 'bg-gray-200 dark:bg-white/10 text-white'}`} ><CheckCircleIcon className="w-6 h-6" /></button>
                                                </div>
                                            ))}
                                        </div>
                                        <button onClick={addQuestionToBank} className="w-full py-4 bg-[#007AFF] text-white rounded-2xl font-black shadow-md active:scale-95 transition-all flex items-center justify-center gap-2" >
                                            <PlusCircleIcon className="w-6 h-6" /> {isEditing ? "إضافة سؤال للمجموعة" : "إضافة السؤال للقائمة"} ({questions.length})
                                        </button>
                                    </div>
                                </div>
                            </IosCard>

                            <IosCard title="معاينة الأسئلة (المسودة الحالية)" icon={<ListBulletIcon className="w-5 h-5"/>} color="purple">
                                <div className="custom-scroll overflow-y-auto max-h-[500px] space-y-4 pr-1">
                                    {questions.map((q, index) => (
                                        <div key={q.id} className="ios-glass p-5 rounded-[25px] border border-white/20 relative group shadow-sm transition-all hover:bg-white/40 bg-white/30 text-right">
                                            <div className="flex justify-between items-start mb-2">
                                                <span className="text-[10px] font-black text-blue-500 bg-blue-50 dark:bg-blue-500/10 px-3 py-1 rounded-lg">سؤال {index + 1}</span>
                                                <button onClick={() => removeQuestionFromDraft(q.id)} className="p-2 text-red-400 hover:text-red-600 transition-colors"><TrashIcon className="w-5 h-5"/></button>
                                            </div>
                                            <p className="font-bold text-gray-700 dark:text-white text-sm mb-3 leading-relaxed">{q.text}</p>
                                            <div className="grid grid-cols-2 gap-2">
                                                {q.options.map((opt, idx) => (
                                                    <div key={idx} className={`text-[10px] p-2 rounded-lg border text-right ${q.correct === idx ? 'bg-emerald-50 dark:bg-emerald-500/10 border-emerald-200 text-emerald-700 dark:text-emerald-400' : 'bg-gray-50/50 dark:bg-white/5 border-transparent text-gray-500'}`}>{opt}</div>
                                                ))}
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </IosCard>

                            <div className="fixed bottom-8 left-1/2 -translate-x-1/2 w-full max-w-lg px-6 flex gap-4 z-[100]">
                                <button onClick={resetForm} className="flex-1 py-4 bg-white/90 dark:bg-[#1C1C1E]/90 backdrop-blur-xl border border-white/20 text-gray-600 dark:text-gray-400 rounded-[22px] font-black shadow-2xl active:scale-95 transition-all text-sm font-cairo">إلغاء</button>
                                <button onClick={handleAction} disabled={isPublishing} className="flex-[2] py-4 bg-[#007AFF] text-white rounded-[22px] font-black shadow-2xl shadow-blue-500/30 active:scale-95 transition-all flex items-center justify-center gap-2 font-cairo" >
                                    <PaperAirplaneIcon className="w-5 h-5 -rotate-45" /> {isPublishing ? "جاري الحفظ..." : isEditing ? "حفظ التعديلات النهائية ✨" : "نشر الاختبار للطلاب 🚀"}
                                </button>
                            </div>
                        </motion.div>
                    ) : (
                        <motion.div key="list" initial={{ opacity: 0, x: -20 }} animate={{ opacity: 1, x: 0 }} exit={{ opacity: 0, x: 20 }}>
                            <IosCard title="الاختبارات المنشورة" icon={<QueueListIcon className="w-5 h-5"/>} color="purple">
                                <div className="custom-scroll overflow-y-auto max-h-[calc(100vh-350px)] space-y-4 pr-1">
                                    {quizzes.map((quiz) => (
                                        <div key={quiz.id} className="ios-glass p-5 flex justify-between items-center border border-white/20 dark:border-white/5 rounded-[30px] transition-all hover:bg-white/40 shadow-sm bg-white/20">
                                            <div className="flex items-center gap-4 text-right">
                                                <div className="w-12 h-12 rounded-2xl flex items-center justify-center text-white shadow-lg bg-emerald-500"><CheckCircleIcon className="w-6 h-6"/></div>
                                                <div>
                                                    <h4 className="font-black text-gray-800 dark:text-white text-sm">{quiz.title}</h4>
                                                    <p className="text-[9px] text-gray-400 font-black uppercase tracking-widest">{quiz.courseType} • {quiz.chapter}</p>
                                                </div>
                                            </div>
                                            <div className="flex gap-2">
                                                <button onClick={() => startEdit(quiz)} className="p-3 bg-blue-50 dark:bg-blue-500/10 text-blue-600 rounded-xl hover:bg-blue-600 hover:text-white transition-all active:scale-90 shadow-sm"><PencilSquareIcon className="w-5 h-5" /></button>
                                                <button onClick={() => openDeleteConfirm(quiz.id)} className="p-3 bg-red-50 dark:bg-red-500/10 text-red-600 rounded-xl hover:bg-red-600 hover:text-white transition-all active:scale-90 shadow-sm"><TrashIcon className="w-5 h-5" /></button>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </IosCard>
                        </motion.div>
                    )}
                </AnimatePresence>
            </div>

            {/* رسالة النجاح الاحترافية بالوسط */}
            <AnimatePresence>
                {showSuccessModal && (
                    <div className="fixed inset-0 z-[11000] flex items-center justify-center pointer-events-auto p-6 text-center bg-black/20 backdrop-blur-sm">
                        <motion.div initial={{ scale: 0.8, opacity: 0, y: 50 }} animate={{ scale: 1, opacity: 1, y: 0 }} exit={{ scale: 0.8, opacity: 0, y: -50 }} className="bg-white/95 dark:bg-[#1C1C1E]/95 backdrop-blur-3xl border border-white/40 p-12 rounded-[60px] shadow-2xl flex flex-col items-center gap-5 max-w-sm" >
                            <div className="w-24 h-24 bg-emerald-500 text-white rounded-full flex items-center justify-center shadow-lg animate-bounce"><CheckCircleIcon className="w-16 h-16" /></div>
                            <div>
                                <h3 className="text-2xl font-black text-gray-800 dark:text-white font-cairo">{isEditing ? "تم تحديث الاختبار!" : "تم النشر بنجاح!"}</h3>
                                <p className="text-gray-500 dark:text-gray-400 font-bold mt-2 text-sm font-cairo">تم إشعار الطلاب بالاختبار الجديد وتفعيل التنبيهات 🚀</p>
                            </div>
                            <button onClick={() => setShowSuccessModal(false)} className="mt-4 px-10 py-3 bg-[#007AFF] text-white rounded-2xl font-black text-xs active:scale-95 transition-all">تم</button>
                        </motion.div>
                    </div>
                )}
            </AnimatePresence>
        </div>
    );
};

export default QuizManager;